import React from 'react';

import styled from '@emotion/styled';

import { Modal } from '../../components/Modal/Modal';
import { TableComponent } from '../../components/TableCom';
import { ModalProvider } from '../../context/ModalContext';
import CreateWarehouser from '../../sections/dashboard/user/CreateWarehouser';
import CreateWarehouserModal from '../../sections/dashboard/user/CreateWarehouserModal';

const User = () => {
  return (
    <ModalProvider>
      <Container>
        <CreateWarehouser />
        <TableComponent
          // rigthRevealComponent={rigthRevealComponent}
          tableBaseUrl="authentication-service/v1/warehouse/users"
          filterData={{
            'First Name': 'firstName',
            'Last Name': 'lastName',
            Role: 'warehouseRole',
            'Phone Number': 'phoneNumber',
            // Email: 'email',
            Verified: 'verified',
          }}
          tableHeader={[
            'firstName',
            'lastName',
            'warehouseRole',
            'phoneNumber',
            // 'email',
            'verified',
          ]}
          mappingData={{
            firstName: 'First Name',
            lastName: 'Last Name',
            warehouseRole: 'Role',
            phoneNumber: 'Phone Number',
            // email: 'Email',
            verified: 'Verified',
          }}
        />
      </Container>
      <Modal>
        <CreateWarehouserModal />
      </Modal>
    </ModalProvider>
  );
};

export default User;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
